import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';

export const previewYamlTheme: ThemeOptions['components'] = {
  DsPreviewYaml: {
    styleOverrides: {
      root: {
        position: 'relative',
        color: tokens.primitives.colors.constants.white,
        backgroundColor: tokens.theme.bg.structural.code,
        borderRadius: tokens.theme.radius.sm,
      },
      scroller: ({ ownerState }) => ({
        height: ownerState.height || '100%',
        width: '100%',
      }),
      syntaxHighlight: ({
        ownerState: { horizontalPadding = 44, showLineNumbers },
      }) => ({
        paddingLeft: horizontalPadding + (showLineNumbers ? 30 : 0),
        paddingRight: horizontalPadding,
        paddingTop: 16,
        paddingBottom: 16,
        backgroundColor: 'inherit',
        position: 'relative',
        '& *': {
          color: tokens.primitives.colors.constants.white,
        },
        '& .DsPreviewYaml-PrimitiveValueContainer': {
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
        },
        '& .DsPreviewYaml-Key, & .DsPreviewYaml-Colon, & .DsPreviewYaml-Null, & .DsPreviewYaml-Boolean, & .DsPreviewYaml-Number':
          {
            color: tokens.primitives.colors.green[300],
          },
        '& .DsPreviewYaml-Key': {
          whiteSpace: 'nowrap',
        },
        '& .DsPreviewYaml-Undefined': {
          color: tokens.primitives.colors.grey[300],
        },
        '& .DsPreviewYaml-Link': {
          color: tokens.primitives.colors.blue[300],
          cursor: 'pointer',
          '&:hover': { color: tokens.primitives.colors.blue[300] },
        },
        '& .DsCode-ExpandToggler': {
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '1em',
          width: '1em',
          position: 'absolute',
          userSelect: 'none',
          left: -18,
          top: 0,
          transform: 'translateY(5px)',
        },
        '& .DsPreviewYaml-ChildCount': {
          fontSize: '0.8em',
          lineHeight: '16px',
        },
        '& .DsPreviewYaml-Line': {
          '&-root': {
            position: 'relative',
            whiteSpace: 'pre',
          },
          '&-Marker': {
            content: '""',
            borderRadius: '10px',
            display: 'block',
            position: 'absolute',
            top: -2,
            bottom: -2,
            left: -25,
            width: 3,
            backgroundColor: tokens.primitives.colors.red[400],
          },
          '&-Index': {
            position: 'absolute',
            left: -60,
            '&-LineNumber': {
              position: 'absolute',
            },
            '&-MaxNumber': {
              visibility: 'hidden',
              height: 0,
            },
          },
          '&-Content': {
            position: 'relative',
            display: 'inline',
          },
        },
      }),
      sizeMd: ({ theme }) => theme.typography.C12,
      sizeLg: ({ theme }) => theme.typography.C14,
    },
  },
};
